import { http } from "@/utils/http";
import { ListSearchParam, ListSearchResult, ResponseResult } from "./common.d";

/**
 * ocr识别通用
 * @param url 身份证地址
 * @returns 识别信息
 */
export const fetchCommonOCR = (url: string) => {
  return http.request<ResponseResult<any>>("post", "/file/commonOCR", {
    data: { url }
  });
};
/**
 * ocr识别身份证
 * @param url 身份证地址
 * @returns 识别信息
 */
export const fetchIdcardOcr = (url: string) => {
  return http.request<ResponseResult<any>>("post", "/file/idCardOCR", {
    data: { url }
  });
};
/**
 * ocr识别企业
 * @param url 身份证地址
 * @returns 识别信息
 */
export const fetchCompanyOcr = (url: string) => {
  return http.request<ResponseResult<any>>("post", "/file/licenseOCR", {
    data: { url }
  });
};

export function requestConvertToM4a(url: string) {
  return http.request<ResponseResult<string>>("post", "/file/covertWebaToM4a", { data: { url } });
}


export function checkSignFile(url: string) {
  return http.request<ResponseResult<string>>("post", "/file/check", { data: { url: url } });
}